import {Injectable} from "@angular/core";


@Injectable()
export class DetectBrowserFeatureService {

	constructor() {
	}

	/**
	 * Checks if browser support viewing of pdf files
	 * If the browser supports checking using the  pdfViewerEnabled  property of the Navigator API checking is  done using this feature
	 * If the browser do no support checking using the pdfViewerEnabled feature we fallback to using the old depracated way (using navigator.mimeTypes)
	 */
	public isPdfViewerEnabled(): boolean {
		if ("pdfViewerEnabled" in navigator) {
			return window.navigator["pdfViewerEnabled"] || false;
		} else {
			return this.isSupportPDF();
		}
	}

	private isSupportPDF(): boolean {
		let hasPDFViewer = false;
		try {
			let pdf =
				navigator.mimeTypes &&
				navigator.mimeTypes["application/pdf"]
					? navigator.mimeTypes["application/pdf"].enabledPlugin
					: 0;
			if (pdf) {
				hasPDFViewer = true;
			}
		} catch (e) {
			if (navigator.mimeTypes["application/pdf"] !== undefined) {
				hasPDFViewer = true;
			}
		}
		return hasPDFViewer;
	}

}
